module.exports = __webpack_public_path__ + "static/media/6C.7d4b4bd6.jpg";